import { SensorConfigTechnicalName } from 'src/app/_shared/models/sensor-config-technical-name';

export class InfoTextOutputDto {
  id: number;
  description: string;
  technicalName: SensorConfigTechnicalName;
}
